import { Attachment } from '@/components/shared/AttachmentDisplay/type';
import { useSnackBarMessage } from '@/utils/useSnackBarMessage';
import { useState } from 'react';

export function useAttachmentCaption() {
  const [isEditing, setIsEditing] = useState(false);
  const [attachmentCaption, setAttachmentCaption] = useState<string>('');
  const { showSnackBar } = useSnackBarMessage({ variant: 'filled' });

  const handleCaption = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const captionValidator = (selectedAttachment: Attachment, referenceId?: string) => {
    const validationRules = [
      { valid: !!referenceId, message: 'ReferenceId ID is missing.' },
      { valid: !!selectedAttachment?.id, message: 'Attachment ID is missing.' },
      { valid: !!attachmentCaption?.trim(), message: 'Caption cannot be empty.' },
      { valid: attachmentCaption !== selectedAttachment?.caption, message: 'Caption is unchanged.' },
    ];

    for (const { valid, message } of validationRules) {
      if (!valid) {
        showSnackBar(message, 'error');
        return false;
      }
    }

    return true;
  };

  return {
    isEditing,
    setIsEditing,
    attachmentCaption,
    setAttachmentCaption,
    handleCaption,
    captionValidator,
  };
}
